var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-layout', {
    attrs: {
      "width": "100%",
      "max-width": "1024"
    }
  }, [_c('console-title', [_vm.notification._id ? _c('span', [_vm._v("공지상세")]) : _c('span', [_vm._v("공지등록")])]), _c('console-body', [_c('v-row', [_c('v-col', {
    staticClass: "py-0 pr-md-1",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    staticClass: "mx-1",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "제목",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.notification.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "subject", $$v);
      },
      expression: "notification.subject"
    }
  })], 1)], 1)], 1), _c('v-col', {
    staticClass: "py-0 pl-md-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mx-1 mt-3 mt-md-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', [_c('span', {
    staticClass: "subtitle-2"
  }, [_vm._v("상단고정")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.notification.isNotice,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "isNotice", $$v);
      },
      expression: "notification.isNotice"
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4 mx-1",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("상세정보")]), _c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.notification.content,
      callback: function callback($$v) {
        _vm.$set(_vm.notification, "content", $$v);
      },
      expression: "notification.content"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "my-6"
  }, [_c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }